import React, { useEffect, useMemo, useState } from 'react';
import Proptypes from 'prop-types';
import { Provider } from 'use-http';
import { fetchEventSchema } from '@bingads-webui/ad-library-instrumentation';
import {
  MSG_BEFORE_FETCH,
  MSG_AFTER_FETCH,
  MSG_FETCH_FAILED,
  MSG_EXCEPTION,
} from './constants';
import {
  mapDomainToAPIEndpoint,
  getApiNameFromUrl,
  getReqIdFromRoute,
} from './helpers';

export const FetchProvider = (props) => {
  const { instrumentation } = props;
  const [APIEndpoint, setAPIEndpoint] = useState('');

  instrumentation.addScenario({
    scenario: [
      ...fetchEventSchema.scenario,
    ],
  });

  // eslint-disable-next-line react/prop-types
  const fetchScenario = instrumentation.fetchEvent.create();
  const fetchTrace = fetchScenario.fetchTrace.create();
  const fetchError = fetchScenario.fetchError.create();

  const fetchOptions = useMemo(() => ({
    interceptors: {
      request: ({ options, url, route }) => {
        const fullUrl = `${url}/${route}`;
        fetchTrace.trace(MSG_BEFORE_FETCH, getApiNameFromUrl(fullUrl), getReqIdFromRoute(route), options.method);
        return options;
      },
      response: ({ response }) => {
        if (response.ok) {
          fetchTrace.trace(`${MSG_AFTER_FETCH}: ${JSON.stringify(response.data)}`, getApiNameFromUrl(response.url), getReqIdFromRoute(response.url));
        } else {
          fetchError.error(`${MSG_FETCH_FAILED}: ${response.status} ${response.statusText} ${JSON.stringify(response.data)}`, getApiNameFromUrl(response.url), getReqIdFromRoute(response.url));
        }
        return response;
      },
    },
    onError: (error) => {
      fetchError.error(`${MSG_EXCEPTION}: ${JSON.stringify(error)}`);
    },
  }), [fetchError, fetchTrace]);

  useEffect(() => {
    const domain = window.location.hostname;
    setAPIEndpoint(mapDomainToAPIEndpoint(domain));
  }, []);

  return (
    <Provider url={APIEndpoint} options={fetchOptions}>
      {props.children}
    </Provider>
  );
};

FetchProvider.propTypes = {
  instrumentation: Proptypes.shape({
    addScenario: Proptypes.func.isRequired,
  }).isRequired,
  children: Proptypes.node.isRequired,
};
